export { AiConfigureMenu } from './AiConfigureMenu';
export { aiConfigureDestinations, buildAiConfigureItems } from './destinations';
